export const SEKTOR_DATA = {
  Finans: ["Banka Şubesi", "Katılım Bankası", "Döviz Bürosu"],
  Gayrimenkul: [
    "Emlak Ofisi",
    "Konut Satış",
    "Günlük Kiralık",
    "Ticari Kiralama",
    "Site Yönetimi",
  ],
  "Cam & Alüminyum": ["Cam Balkon", "Vitrin Cam", "Doğrama", "Korkuluk"],
  "Demir & Çelik": ["Ferforje", "Çelik Kapı", "Çelik Konstrüksiyon", "Çelik Kasa", "Çelik Dolap", "Çelik Çatı", "Çelik Merdiven", "Çelik Güvenlik Kabini", "Hattane"],
  Güvenlik: ["Güvenlik Şirketi", "Bodyguard"],
  Spor: [
    "fitness",
    "Personal Trainer",
    "Futbol Kulübü",
    "Basketbol Kulübü",
    "plates",
    "uzak doğu spor kursları",
  ],
  "Evcil Hayvan": ["Pet Shop", "Veteriner", "görüntüleme merkezi"],
  Kozmetik: ["Makyaj Ürünleri", "Parfümeri"],
  Kırtasiye: ["Ofis Malzemeleri", "Okul Malzemeleri"],
  Matbaa: ["4 renk Baskı Hizmetleri", "Kartvizit", "Broşür", "ozalit baskı"],
  Danışmanlık: [
    "bilirkişi",
    "Marka panent Danışmanlığı",
    "Yönetim Danışmanlığı",
    "Mali Müşavir",
    "İnsan Kaynakları",
    "yeminli mali müşavir",
  ],
  Hukuk: ["Avukatlık Bürosu", "Arabuluculuk"],
  İnşaat: [
    "Alçıpan - boya",
    "Altyapı taahhüt",
    "armatür ürünleri",
    "Asansör/Merdiven",
    "asfalt şantiyesi",
    "bahçe Yapı Market",
    "beton santrali",
    "Briket-Tuğla-Kiremit",
    "Cam Sanayi",
    "Çatı - Sistemleri",
    "çivi imalat ve satış",
    "Demir - çimento satış",
    "demir kalıp ustası",
    "Doğrama/Pencere",
    "duşakabin",
    "Duvar Kağıdı",
    "duvar ustası",
    "El Aletleri",
    "fayans - Seramik",
    "fayans ustası",
    "fore kazık",
    "havuz imalat",
    "Havuz Yan Sanayi",
    "Isıtma /Soğutma",
    "İnşaat Malzemeleri",
    "İskele Kalıp",
    "izalasyon hizmeti",
    "izalasyon malzemeleri",
    "kapı kolu imalat",
    "Kapı Ve Pencere Sistemleri",
    "kat karşılığı inşaat - müteahhitlik hizmeti",
    "Kazı -Yıkım Hafriyat",
    "Köprü İnşaatı",
    "kumocağı",
    "küpeşte",
    "Lavabo-Küvet-Klozet",
    "Mantolama",
    "Mermer Ve Doğal Taşlar",
    "Mimar-Mühendisler",
    "Mutfak Ve Banyo",
    "nalbur",
    "Prefabrik Yapı",
    "sıva ustası",
    "şömine",
    "Tadilat - dekorasyon hizmeti",
    "tel çit",
    "yangın söndürme ürünleri",
    "Yapı Denetim Hizmetleri",
    "Yapı Kimyasalları",
    "Yer Kaplamaları",
    "yerden ısıtma sistemleri",
    "Yol Yapımı",
    "musluk imalat",
  ],
  "Bilişim Teknoloji": [
    "Bilgisayar - elektronik satış",
    "Bilgisayar Tamiri",
    "ceo hizmetleri",
    "E-Ticaret Yazılımı",
    "host hizmetleri",
    "Mobil Uygulama",
    "Network & Kurulum",
    "sosyal medya yönetimi",
    "Telefon Satış - tamir",
    "Veri Kurtarma",
    "Web Yazılım",
  ],
  Otomotiv: [
    "Aksesuar",
    "Batarya/Akü/Pil",
    "Bisiklet /Motosiklet tamir",
    "Bisiklet /Motosiklet ve ekipmanları",
    "cam filmi",
    "çıkma yedek parça",
    "Egzoz Emisyon Ölçüm İstasyonları",
    "eksoz tamir",
    "Elektrik Ve Elektroniği",
    "Kaporta Boya",
    "Kasa Dorse İmalatı",
    "lastik satışı",
    "Lastik tamiri",
    "Modifiye Firmaları",
    "oto cam",
    "oto kalorifer",
    "oto koltuk döşeme",
    "oto kuaför",
    "Oto Lastik Kaplama",
    "Oto Parçacıları",
    "Oto Tamir",
    "oto yıkama",
    "oto yıkama detaylı temizlik",
    "Otogaz Dönüşüm Sistemleri",
    "yetkili bayi",
    "pasta cila oto kaplama",
    "Rektefiye",
    "Rot Balans",
    "ses sistemleri",
    "trafik müşaviri",
    "galeri 2. El binek araç",
  ],
  "Ticari Araç": ["kamyon", "minibüsler", "Tır", "traktör"],
  "deniz araçları": [],
  "deniz aracı ekipmanları": [],
  Temizlik: [
    "dış cephe temizliği",
    "Ev Temizliği",
    "Ofis Temizliği",
    "İnşaat Sonrası Temizlik",
    "ilaçlama hizmetleri",
    "cam temizliği",
  ],
  "Tarım ve hayvancılık": [
    "Büyükbaş besicilik",
    "küçükbaş bescilik",
    "Seracılık",
    "Tarım Ürünleri",
    "tarım ilaçları",
    "veteriner",
    "hayvan yemi",
  ],
  "ulaşım Lojistik": [
    "Asansörlü Nakliyat",
    "Depo Hizmeti",
    "evden eve nakliye",
    "gümrük hizmetleri",
    "Kargo Firması",
    "Kimyasal Taşıma",
    "kiralık araç - rentecar",
    "kiralık vinç hizmetleri",
    "kurye firmaları",
    "Nakliye Taşımacılık",
    "otobüs firmaları",
    "Otomotiv Taşımacılık",
    "Parsiyel Taşıma",
    "Şehirlerarası Taşıma",
    "turizm taşıma hizmetleri",
    "uluslar arası nakliye",
  ],
  peyzaj: [
    "dış mekan süs bitkileri",
    "fidan satış",
    "ağaçlandırma",
    "çiçekçi",
    "iç mekan süs bitkileri",
  ],
  "Sağlık - Doktor": [
    "Psikolog",
    "Diyetisyen",
    "Fizyoterapist",
    "dahiliye",
    "kardiyoloji",
    "ortopedi",
    "beyin cerrahı",
    "onkoloji",
    "diş",
    "hemotoloji",
    "kalp damar cerrahisi",
    "genel cerrehi",
    "kadın doğum",
    "kulak burun boğaz",
    "algoloji",
    "göğüs hastalıkları",
    "enfeksiyon hastalıkları",
    "cildiye",
    "nöroloji",
    "çocuk",
    "radyoloji",
    "romotoloji",
    "anestezi",
    "reanimasyon",
    "ürüloji",
    "endokrinoloji - metabolizma hastalıkları",
    "gastroentoroloji",
    "göğüç cerrahisi",
    "genetik hastalıkları",
    "geriatri",
    "göz",
    "nefroloji",
    "immünoloji ve alerji hastalıkları",
  ],
  Sağlık: [
    "alternatif tıp",
    "Diş Kliniği",
    "ecza deposu",
    "Eczane",
    "Estetik Merkezi",
    "Fizik Tedavi",
    "görüntüleme merkezi",
    "hacemat",
    "inme merkezi",
    "Medikal Ürünler",
    "nükleer tıp",
    "organ nakli",
    "Özel Hastane",
  ],
  "Restoran Yeme içme": [
    "Balık restoran",
    "Cafe",
    "dondurma",
    "Fast Food",
    "Kebapçı",
    "Lokanta",
    "müzikhol - bar",
    "Pide ve lahmacun salonu",
    "Pizza",
    "Tatlı Kafeler",
    "Pastaneler",
    "Çay Bahçesi",
    "Börekçi"
  ],
  "Gıda içecek": [
    "aktar",
    "baharat",
    "bakkal",
    "Bal üretici ve satıcı",
    "balık Deniz ürünleri",
    "büfe",
    "Çiğköfteci",
    "çikolata - şeker",
    "Diyet Ve Sağlıklı Beslenme",
    "Dondurulmuş Gıda",
    "Et ve et Ürünleri",
    "gıda toptancısı",
    "Glutensiz Ürünler",
    "hayvansal gıdalar üretici ve satıcı",
    "hazır yemek Catering Firmaları",
    "kahve satış",
    "Konserve & Hazır Gıda",
    "Kurutulmuş Gıda",
    "Kuruyemiş Bakliyat",
    "manav",
    "market",
    "Online Market",
    "sebze meyve toptancısı",
    "Soğuk Hava Depoları",
    "Su Ve Maden Suları",
    "Süt ve süt Ürünleri",
    "şarküteri",
    "Tarımsal Gıda",
    "Tavuk Ve Yumurta Sektörü",
    "tuz üreticisi",
    "Un Fabrikaları",
    "Unlu Mamuller - fırın",
    "Vegan & Vejetaryen",
    "yöresel ürünler",
    "Zeytin ve Zeytinyağı üretici - satıcı",
  ],
  "makine sanayi": [
    "Ağır İş Makinaları",
    "Ahşap İşleme Makineleri",
    "Ahşap İşleme Makineleri Üreticileri",
    "Ambalaj Makineleri",
    "Ayakkabı Makineleri",
    "Boya Makineleri",
    "Buhar Ve Kızgın Kazan Üreticileri",
    "Büro Makineleri",
    "Delici & Sondaj Makineleri",
    "demir kalıp",
    "Deri Makineları",
    "Dikiş Nakış Makineleri",
    "Dokuma Ve Örgü Makineleri",
    "elektrostatik boya",
    "Endüstriyel Bakım",
    "Endüstriyel Tesis Makineleri",
    "Forklift Ve Transpalet Üreticileri",
    "Genel Makine Sanayi",
    "Gıda Makinaları",
    "Hidrafor Üreticileri",
    "hurda demir",
    "İkinci el iş makineleri",
    "İnşaat Makinaları",
    "İstifleme Makinaları",
    "İş Makinaları",
    "iş makinaları tamir ve bakım",
    "Kağıt Makineleri",
    "Kapı Kilit Üretimi",
    "Kalorifer Kazanları Üreticileri",
    "Kaynak Makineları Ve Elektrotları",
    "kiralık iş makinaları",
    "Kompresör Hava Tankları Üreticileri",
    "Kuyumculuk Makineleri",
    "Laboratuvar Malzemleri",
    "Makine Elemanları",
    "Makine Servis",
    "Matbaa Makineleri",
    "Mermer İşleme Makineleri",
    "Metal İşleme Makineleri",
    "Mobil Vinç Ve Kule Vinç Üreticileri",
    "Mobilya Makinaları",
    "nikelaj kaplama",
    "petrokimya ürünleri",
    "plastik enjeksiyon",
    "plastik hammadde",
    "plastik hurda",
    "plastik kalıp",
    "Plastik Üretim",
    "polisaj hizmeti",
    "Pompa/Kompresör",
    "Soğutma Havalandırma Klima Üreticileri",
    "Tarım Makinaları Ve Aletleri",
    "Tekstil Makinaları",
    "Temizlik Makinaları",
    "Torna Tezgahları",
    "tornacı",
    "Vinç Ve Caraskal Üreticileri",
    "Yedek Parça Sanayi",
  ],
  "Alüminyum Ve Yan Sanayi": [
    "Alüminyum Doğrama",
    "Alüminyum Folyo",
    "Alüminyum İmalatı",
    "Alüminyum Levha",
    "Alüminyum Tel",
  ],
  "hizmet sektörü": [
    "anahtarcı - çilingir",
    "ara işleri yevmiyeci",
    "ardiye ve depoculuk hizmetleri",
    "ayakkabı tamircisi",
    "bahçıvan",
    "beyaz eşya tamircisi",
    "çocuk bakıcısı",
    "davet ve organizasyon",
    "Dezenfeksiyon",
    "düğün salonu",
    "dokuma makinesi tamiri",
    "Endüstriyel fabrika temizliği",
    "Fotoğraf stüdyosu",
    "galvaniz hizmeti",
    "Günlük temizlik",
    "haç umre organizasyonu",
    "halı yıkama",
    "hizmetli - ev işleri yardımcısı",
    "kiralık uçak helikopter",
    "koltuk yıkama",
    "kombi bakım tamir",
    "muhasebe ve mali müşavir",
    "reklam tabela vinil baskı",
    "saat tamircisi",
    "sigorta aracılık hizmetleri",
    "sihhi tesisatçı",
    "sosyal medya yönetimi",
    "Su & Damacana",
    "taksi",
    "tercümanlık ofisi",
    "toplu mesaj sms",
    "triko makine tamiri",
    "uydu tamiri",
    "yaşlı bakım",
    "yeminli mali müşavir",
    "klima kurulum ve tamir",
    "doğalgaz tesisat",
  ],
  "hediyelik ürünler": ["promosyon ürünleri", "hediyelik eşyalar"],
  "Ambalaj Ve Yan Sanayi": [
    "Ambalaj poşet üretim",
    "Gıda Ambalaj",
    "Teneke Kutu",
  ],
  "Bahçe Ve Ev": [
    "Akvaryum",
    "avize",
    "Bahçe Bitkileri",
    "Bahçe Makine Ve Aletleri",
    "Cam Eşya aksesuar",
    "Çelik Kapı",
    "Çelik Kasa Ve Dolaplar",
    "çeyiz mağazası",
    "Ev Aletleri",
    "Mutfak Aletleri",
    "peyzaj Çevre Düzenleme",
    "temizlik ürünleri",
    "tuhafiye",
    "tüpgaz",
    "Yatak Yorgan",
    "züccaciye ürünleri",
  ],
  "Elektrik Ve Elektronik": [
    "Alarm Sistemleri",
    "Aydınlatma Sistemleri",
    "Beyaz Eşya Mağazası",
    "Elektrik - Taahhüt",
    "elektrik malzeme satışı",
    "Elektrik Proje",
    "elektrikçi",
    "Elektrik-Elektronik Firmaları",
    "Elektrikli Ev Aletleri",
    "Fotoğraf Makinesi Satış ve Tamir",
    "Jeneratör",
    "Kamera ve güvenlik Sistemleri",
    "Kesintisiz Güç Kaynakları",
    "Pano Sistemleri",
    "Radyo-Tv Elektronik tamir",
    "Ses/Işık/Görüntü Sistemleri",
    "Tıbbi Cihazlar",
    "Uydu Sistemleri",
  ],
  Enerji: [
    "araç şarj ekipmanları",
    "araç şarj istasyonu",
    "Güneş paneli",
    "hidro elektrik santrali",
    "rüzgar türibünü",
  ],
  "Belgelendirme Ve Denetim": [
    "Akredite Kuruluşlar",
    "ISO Belgelendirme",
    "laboratuvarlar",
    "Muayene Kuruluşları",
  ],
  "Geri Dönüşüm Hizmetleri": [
    "cam geri dönüşüm",
    "karton kağıt geri dönüşüm",
    "metal geri dönüşüm",
    "pil Akü geri dönüşüm",
    "plastik geri dönüşüm",
    "tekstil geri dönüşüm",
    "varil geri dönüşümü",
  ],
  "Tekstil Giyim Ve Aksesuarlar": [
    "aksesuar - Takı",
    "Ayakkabı satıcısı",
    "ayakkabı üreticisi",
    "bayan giyim  (fason üretim)",
    "Bayan Giyim - satış",
    "ceket (fason üretim)",
    "Tente-Branda-Pergula",
    "Çamaşır Yıkama Hizmetleri",
    "Çanta - üretici - satıcı",
    "Çocuk Giyim",
    "Çorap - üretici",
    "Dar Dokuma-Etiket - üretici",
    "Deri Ve Yan Sanayi - imalat",
    "Deri Yan Malzemeleri satış",
    "Deri-Kürk Giyim - satış",
    "Kumaş Üretimi",
    "Kumaş satış",
    "Düğme",
    "erkek Giyim - satış",
    "Ev Tekstili",
    "Fermuar  satış",
    "Forma Üretimi",
    "Gelinlik Abiye - üretim satış",
    "Giyim Tasarım Hizmetleri",
    "gömlek (fason üretim)",
    "Gömlek-Kravat  satış",
    "Ham Deri - üretici",
    "Havlu Bornoz - üretici",
    "Hazır Giyim / Mağaza",
    "İç Giyim - satış",
    "İç Giyim - üretici",
    "iç giyim (fason üretim)",
    "iplik - satış",
    "İplik - üretici",
    "İşlenmiş Deri - üretici",
    "Gömlek kumaşı toptan satışı",
    "kot pantolon - Jeans - satış",
    "Konfeksiyon - fason",
    "Kostüm",
    "kot pantolon - yıkama",
    "Kuru Temizleme",
    "Mayo - üretici",
    "modelist",
    "Nakış",
    "Örme Kumaş - üretici",
    "Pamuk",
    "pantolon (fason üretim)",
    "penye (fason üretim)",
    "seccade dokuma  - üretici",
    "Spor Giyim - satış",
    "Stil Danışmanlığı",
    "Suni Deri - üretici",
    "şapka imalat ve satış",
    "Tabakhaneler",
    "Tekstil Baskı",
    "Tekstil Danışmanlığı",
    "Tekstil Entegre Üretim",
    "Tekstil Yan Ürünleri",
    "Tekstil-Boya Apre",
    "Tekstil-Boya Üretimi",
    "terlik imalat",
    "Terzi",
    "Triko - satış",
    "Triko - üretici",
    "Vitrin Mankeni",
    "vitrin tasarımcısı",
  ],
  "İş Güvenliği": [
    "İş Güvenliği Malzemeleri",
    "Ortak Sağlık Ve Güvenlik Birimi",
    "Sedex Belgeli Kuruluşlar",
    "SRC psikoteknik",
  ],
  "Kimya Sanayi": [
    "Gazlar",
    "Gübre",
    "Kimyasal Madde",
    "Kozmetik Parfümeri Şampuan",
    "Tekstil Kimyasalları",
  ],
  "Kişisel Bakım": [
    "bayan Kuaför",
    "Cilt Bakımı - güzellik",
    "epilasyon - lazer",
    "erkek kuaför",
    "estetik medekal güzellik.",
    "kalıcı makyaj",
    "manikür - pedikür",
    "masaj",
    "parfümeri",
    "protez tırnak",
    "SPA - merkezi",
    "tırnak bakım",
  ],
  "Sanatçılar /Eğlence": [
    "Arebesk Fantazi sanatçısı",
    "Davul Zurna",
    "folklor ekibi",
    "Organizatör",
    "Pop sanatçısı",
    "Pyanist",
    "ritm",
    "Rock sanatçısı",
    "Tasavvuf müzik sanatçısı",
    "THM sanatçısı",
    "TSM. sanatçısı",
  ],
  "Kültür / Sanat": [
    "ebru sanatçısı",
    "Fotoğraf Sanatcısı",
    "hattat",
    "Heykel Traş",
    "Müzisyen",
    "Ressam",
    "senarist",
    "Sinema",
    "Tiyatro",
    "yazar",
  ],
  "Basın Ve Yayın": [
    "cast ajansı",
    "dron operatörü",
    "editör",
    "fm radyo",
    "influenza",
    "kameraman",
    "oyuncu",
    "senarist",
    "spiker",
    "televizyon  sektörü",
    "youtuber",
    "yönetmen",
  ],
  Kuyumculuk: ["kuyumcu", "Altın Atölyesi", "kuyumcu makinaları imalat satış"],
  "Maden Ve Metal": [
    "Değerli Madenler",
    "Demir/Çelik/Döküm",
    "Kömür satış",
    "Maden Araştırma",
    "Madeni Yağlar",
    "Metal Sektörü",
    "Sondaj Firmaları",
  ],
  "Mobilya Dekorasyon": [
    "Ev Mobilyası",
    "Bebek Mobilyası",
    "Genç Odası",
    "Halı - kilim",
    "kapı imalat ve satış",
    "Kapı Pencere",
    "koltuk döşeme",
    "mutfak mobilyası",
    "Ofis Büro Mobilya",
    "Ofis Koltuğu İmalat Satış",
    "Mobilya İmalat Satış",
    "Oturma Grubu",
    "Mefruşat - Perde",
    "Yatak Odası",
    "yüzey kaplama ürünleri",
  ],
  "Ormancılık Ve Yan Ürünleri": [
    "Ahşap Malzeme İmalatı",
    "ahşap masa",
    "ebatlama sunta kesim",
    "Kereste Tomruk",
    "marangöz",
    "mobilya aksesuar",
    "Parke",
    "Sunta Kontraplak",
  ],
  "Petrol Ve Yan Sanayi Ürünleri": [
    "benzin istasyonu",
    "madeni yağlar",
    "Deniz yakıtları (Marine fuel)",
  ],
  "Eğitim Ve Kurslar": [
    "bilgisayar kursu",
    "Dans Kursları",
    "diksiyon kursu",
    "dil eğitim kursu",
    "fotoğrafçılık kursu",
    "futbol kursu",
    "Güzellik uzmanlık kursu",
    "kuaförlük eğitimi",
    "müzik kursları",
    "özel güvenlik kursu",
    "spikerlik kursu",
    "sürücü kursu",
    "takı kursu",
    "tasarım kursu",
    "Yazılım kursu",
    "yemek kursu",
    "yöneticilik kursu",
  ],
  Eğitim: ["Özel Okul", "Anaokulu"],
  "Turizm Ve Hizmet": [
    "apart otel",
    "Aqua Parklar",
    "bungalov",
    "kaplıca termal otel",
    "kayak merkezi",
    "otel",
    "pansiyon",
    "Seyahat Acentesi",
    "Turizim Rehberleri",
    "vize işlemleri",
    "yüzme havuzu",
  ],
  antikacı: [],
  "cafe bilardo salonu": [],
  "çoçuk parkı ürünleri": [],
  ekspertiz: [],
  "fırın boya": [],
  "fiberglas imalat": [],
  "forklift satış bakım": [],
  "gemi söküm": [],
  gözlükçü: [],
  "halıfleks döşeme": [],
  "hamam  sauna": [],
  kahvehane: [],
  "kitap satış": [],
  "kozmetik fırça imalatı": [],
  "kuaför malzemeleri satış": [],
  "müzik aletleri satış": [],
  oyuncakçı: [],
  "hırdavat ve teknik malzemeler": [
    "Hortum (Endüstriyel)",
    "Hortum (Sulama)",
    "Cıvata Üretim ve Satış",
    "Raf Ürünleri"
  ],
  "dış ticaret": [],
  poligon: [],
  "polyester kabin imalat": [],
  "pres işlemi": [],
  "sanayi tipi dikiş makinaları": [],
  "Silah - avcılık atıcılık malzemeleri": [],
  "susam üreticisi": [],
  "SÜNGER İMALATI": [],
  "telefon santral kurulumu": [],
};

export const ANA_SEKTORLER = Object.keys(SEKTOR_DATA);
